import { render, staticRenderFns } from "./SocialNetworkLink.vue?vue&type=template&id=35e9608e"
import script from "./SocialNetworkLink.vue?vue&type=script&lang=js"
export * from "./SocialNetworkLink.vue?vue&type=script&lang=js"
import style0 from "./SocialNetworkLink.vue?vue&type=style&index=0&id=35e9608e&prod&lang=less&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports